<template>
<div class="home-main smui">
    <full-page>
        <section class="page-header fp-section">
            <h1 class="project-name">smui</h1>
            <h2 class="project-tagline">smui 一套适用于PC管理系统的Vue组件库</h2>
            <a href="http://gitlab.alibaba-inc.com/front_web/smui-dev.git" class="btn">源码</a>
            <a href="./home/index.html" class="btn">组件库</a>
            <a href="./platform/index.html" class="btn">实例</a>
            <rotage-box></rotage-box>
        </section>
        <section class="fp-section sky-1">
            <ul class="flex">
                <li class="logo-item">
                    <div class="logo vue-logo"></div>
                    <div class="desc">
                        <a href="http://cn.vuejs.org/" target="_blank">Vue</a>
                    </div>
                </li>
                <li class="logo-item">
                    <div class="logo webpack-logo"></div>
                    <div class="desc">
                        <a href="/home/">Components</a>
                    </div>
                </li>
                <li class="logo-item">
                    <div class="logo doc-logo"></div>
                    <div class="desc">
                        <a href="https://linkwisdom.gitbooks.io/smui/content/">Documents</a>
                    </div>
                </li>
            </ul>
        </section>
        <section class="fp-section sky-2">
            <div class="flex">
                <div class="flex-box info">
                    <h1>{{terms.Dialog.title}}</h1>
                    <p v-for="item in terms.Dialog.desc">{{item}}</p>
                </div>
                <dialog-panel class="flex-box">
                    <div slot="title">弹窗标题</div>
                    <div slot="content">弹窗内容</div>
                </dialog-panel>
            </div>
        </section>
        <section class="fp-section sky-3 flex">
            <div class="flex-box info">
                <h1>{{terms.DatePicker.title}}</h1>
                <p v-for="item in terms.DatePicker.desc">{{item}}</p>
             </div>
            <div class="flex-box" style="width: 600px">
                <date-picker></date-picker>
            </div>
        </section>
        <section class="fp-section comp-list sky-4">
            <img src="http://image.uc.cn/s/uae/g/2p/material/images/components-x1.png" id="components-list">
        </section>
        <section class="fp-section">
            <post-script :src="'//jsfiddle.net/linkwisdom/56L5rvyg/embed/'"></post-script>
        </section>
        <section class="fp-section sky-5">
            <doc class="flex-box doc"></doc>
        </section>
        <section class="fp-section page-footer">
            <div class="wrapper">
                <a href="http://cn.vuejs.org/">Vue</a>
                <a href="https://sm-ui.github.io/">smui.io</a>
                <a href="https://github.com/sm-ui/">github/smui</a>
                <a href="https://www.npmjs.com/package/smui">npm/smui</a>
            </div>
            <div class="wrapper">
                <div>2017©神马商业搜索前端组</div>
            </div>
        </section>
    </full-page>
</div>
</template>

<script type="text/javascript">
import Vue from 'vue'
import Doc from 'components/Doc'
import DialogPanel from 'smui/DialogPanel'
import FullPage from './FullPage'
import RotageBox from './RotageBox'
import DatePicker from 'smui/DatePicker'
import terms from './terms'

require('resource/css/normalize.css')
require('resource/css/stylesheet.css')
require('resource/css/github-light.css')

require('smui/style/skin.less')
require('resource/css/main.less')
require('resource/css/demo.less')

const PostScript = {
    props: ['src'],
    render(createElement, context) {
        return createElement(
            'script',
            {
                attrs: {src: this.src}
            }
        )
    }
}

export default {
    data() {
        return {
            terms
        }
    },
    components: {
        Doc,
        DialogPanel,
        FullPage,
        PostScript,
        RotageBox,
        DatePicker
    }
}

setTimeout(() => {
    new Vue({
        extends: exports.default
    }).$mount('#main')
}, 500)

</script>

<style type="text/css" lang="less">
@image-url: 'http://image.uc.cn/s/uae/g/2p/material/images/sky/';

.home-main.smui .page-header,
.home-main.smui .page-header * {
    text-align: center !important;
}

#components-list {
    width: 700px;
    margin: 0 auto;
    display: block;
}

.comp-list:hover #components-list {
    width: 100%;
    position: fixed;
    transition: width 3s ease-in-out;
}

.home-main {
    .logo-item:hover {
        transform: rotatey(360deg);
        transition-duration: 2s;
        transition-timing-function: ease-in-out;
    }

    .logo {
        display: inline-block;
        width: 250px;
        height: 250px;
        margin: 30px 30px;
        border-radius: 50%;
        background-image: url(http://cn.vuejs.org/images/logo.png);
        background-size: 170px 170px;
        background-position: 40px 56px;
        background-repeat: no-repeat;
        vertical-align: top;
        box-shadow: 0 0 50px 50px rgba(3, 169, 244, 0.26) inset;
    }
    iframe {
        min-height: 90vh;
    }

    .page-footer {
        background-color: rgb(33, 33, 33);
        color: rgba(255, 255, 255, 0.541176);
        font-size: 16px;
        
        .wrapper {
            width: 800px;
            display: flex;
            margin: 20px auto;
        }
        a {
            display: inline-block;
            line-height: 30px;
            min-width: 200px;
            color: rgba(255, 255, 255, 0.7);
        }
    }
    .vue-logo {
        background-image: url(http://cn.vuejs.org/images/logo.png);
        background-size: 120px 120px;
        background-position: 58px 77px;
    }
    .webpack-logo {
        background-image: url(http://image.uc.cn/s/uae/g/2p/material/images/webpack.png);
        background-position: 37px 40px;
    }
    .doc-logo {
        background-image: url('http://image.uc.cn/s/uae/g/2p/material/images/doc.png');
        background-size: 120px 120px;
        background-position: 72px 67px; 
    }
    .flex {
        display: flex;
        justify-content: center;
    }
    .flex-box {
        display: inline-block;
        color: #FFF;
        font-size: 14px;
        min-width: 300px;
        height: 60vh;
        border-radius: 10px;
        margin: 20px 40px;
        padding: 10px;
        position: relative;
        background-color: rgba(255, 255, 255, 0.5);

        .info {
            width: 500px;
        } 
    }
    .flex-box.doc {
        color: #333;
        height: 80vh;
        width: 80vw;
        margin: 10vh 10vw;
        background-color:  rgba(255, 255, 255, 0.6);
        overflow-y: scroll; 
    }
    .date-picker #canlendar-button {
        padding: 10px 5px;
        background-color: #FFF;
    }
    .fp-section {
        max-height: 100vh;
        overflow-y: hidden;
        position: relative;
    }

    .logo-item:hover {
        .desc {
            filter: none;
        }
    }
    .desc {
        color: #FFF;
        font-size: 14px;
        text-align: center;
        line-height: 2em;
        border-radius: 50%;
        filter: blur(5px);
        margin: 0 20px;
        background-color: rgba(3, 169, 244, 0.26);
        a {
            color: #FFF;
        }
    }

    .blur {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        z-index: -10;
        background: rgba(76, 175, 80, 0.32);;
        /*filter: blur(5px);*/
    }
    .sky-1::before {
        .blur;
        background-image: url('@{image-url}sky-11.jpg');
    }
    .sky-2::before  {
        .blur;
        background-image: url('@{image-url}sky-12.jpg');
    }
    .sky-3::before {
        .blur;
        background-image: url('@{image-url}sky-13.jpg');
    }
    .sky-4 {
        .blur;
        background-image: url('@{image-url}sky-3.jpg');
    }
    .sky-5 {
        .blur;
        background-image: url('@{image-url}sky-15.jpg');
    }
    .sky-6 {
        .blur;
        background-image: url('@{image-url}sky-16.jpg');
    }
    .dialog {
        display: block;
        position: relative;
        margin: 50px 100px;
    }
    .layer.hidden {
        display: block;
    }
    .rotage-box {
        min-width: 100px;
        min-height: 100px;
        padding: 25px;
        position: absolute;
        right: 100px;
        bottom: 50px;
        z-index: 9999;
    }
}

.fp-controller .fp-controller-dotted.fp-controller-dotted {
    width: 10px;
    height: 10px;
    margin-bottom: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.13);
    border: 1px solid rgba(0, 188, 212, 0.77);
    transition: all 0.5s ease-in-out;
    cursor: pointer;
}

.fp-controller-dotted:hover {
    box-shadow: 0 0 5px 5px rgba(255, 255, 255, 0.13);
}

.fp-controller .fp-controller-dotted.fp-controller-dotted.active {
    background: #159168;
    border-color: #fff;
}

</style>


// WEBPACK FOOTER //
// main.vue?3cdf6448